/**
 * Root Application Component
 *
 * This is the entry point that assembles all providers and the router.
 * Keep this file minimal - it should only compose providers.
 */

import { AppProviders } from './providers';
import { AppRouter } from './router';

export function App() {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}

export default App;

